/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cannotpublishlisting2Inputs */

const en_cannotpublishlisting2 = /** @type {(inputs: Cannotpublishlisting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot publish listing`)
};

const de_cannotpublishlisting2 = /** @type {(inputs: Cannotpublishlisting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort kann nicht veröffentlicht werden`)
};

/**
* | output |
* | --- |
* | "Cannot publish listing" |
*
* @param {Cannotpublishlisting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cannotpublishlisting2 = /** @type {((inputs?: Cannotpublishlisting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cannotpublishlisting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cannotpublishlisting2(inputs)
	return de_cannotpublishlisting2(inputs)
});
export { cannotpublishlisting2 as "cannotPublishListing" }